<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon>
        <slot name="title"></slot>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                  limpar();
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="possuiMunicipio">
          <v-col sm="6">
            <combobox-municipio
              @onChange="changeMunicipio"
              :value="payload"
            ></combobox-municipio>
          </v-col>
        </v-row>
        <v-row v-if="!possuiMunicipio || payload.municipioValor">
          <v-col sm="6">
            <v-select
              id="group-solution-select"
              v-model="payload.grupoSolucao"
              item-text="nome"
              item-value="municipioGrupoSolucaoId"
              :items="groupSolutionList"
              :label="`${
                isAT
                  ? 'Grupo de iniciativa'
                  : isGov
                  ? 'Grupo de Fases'
                  : 'Grupo de Solução'
              }`"
              :placeholder="`${
                isAT
                  ? 'Grupo de iniciativa'
                  : isGov
                  ? 'Grupo de Fases'
                  : 'Grupo de Solução'
              }`"
              :return-object="true"
              @change="changeGroupSolution"
            >
              <template slot="no-data">
                Nenhum
                {{
                  isAT
                    ? "Grupo de iniciativa"
                    : isGov
                    ? "Grupo de Fases"
                    : "Grupo de Solução"
                }}
                retornado
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row v-if="!possuiMunicipio || payload.municipioValor">
          <v-col sm="6">
            <SolutionCombobox
              :itens="solucoes"
              :filter="solucao"
              @onChange="change"
              :disabled="!payload.grupoSolucao.grupoSolucaoId"
            ></SolutionCombobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              limpar();
              dialog = false;
            }
          "
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="!payload.grupoSolucao"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { groupSolutionAPI } from "../../API/GroupSolutionAPI";
import { cityGroupSolutionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import SolutionCombobox from "@/modules/solution/components/city/Combobox.vue";
import { compare } from "@/helpers/orderByAsc";
import ComboboxMunicipio from "../../../city/components/ComboboxMunicipio.vue";

export default {
  name: "AppModalImportGroupSolution",
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    possuiMunicipio: { type: Boolean, required: false, default: false },
  },
  components: {
    SolutionCombobox,
    ComboboxMunicipio,
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT", "isGov"]),
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        grupoSolucao: {
          solucoes: [],
        },
      },
      solucao: [],
      dialog: false,
      groupSolutionList: [],
      solucoes: [],
      allSolutions: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    change(event) {
      this.solucao = event;
    },
    limpar() {
      this.solucao = [];
      this.solucoes = [];
      this.payload = {
        municipioId: this.possuiMunicipio ? null : this.$route.params.id,
        grupoSolucao: {
          solucoes: [],
        },
      };
      this.$forceUpdate();
    },
    changeMunicipio(e) {
      this.payload.municipioValor = e;
      this.payload.municipioId = e;
      this.$forceUpdate();

      groupSolutionAPI
        .listNotInCity(e)
        .then((resp) => {
          this.allSolutions = resp.data.sort((a, b) => compare(a, b, "nome"));
          this.groupSolutionList = resp.data.sort((a, b) =>
            compare(a, b, "nome")
          );
        })
        .catch();
    },
    onConfirm() {
      this.setLoading(true);
      const variables = {
        ...this.payload,
        grupoSolucao: {
          grupoSolucaoId: this.payload.grupoSolucaoId,
          grupoSolucaoProjetos: [],
          nome: this.payload.nome,
          solucoes: this.solucao,
        },
      };

      delete variables.municipio;
      cityGroupSolutionAPI
        .create(variables)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success(
            `${
              this.isAT
                ? "Grupo de iniciativa"
                : this.isGov
                ? "Grupo de Fases"
                : "Grupo de Solução"
            } incluído com sucesso`
          );
          this.dialog = false;
          this.solucao = [];
          this.solucoes = [];
          this.payload = {
            municipioId: this.$route.params.id,
            grupoSolucao: {
              solucoes: [],
            },
          };
          this.$emit("onSave");
          this.getGroupSolution();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao incluir ${
              this.isAT
                ? "Grupo de iniciativa"
                : this.isGov
                ? "Grupo de Fases"
                : "Grupo de Solução"
            }`
          );
        });
    },
    changeGroupSolution() {
      this.payload.grupoSolucaoId = this.payload.grupoSolucao.grupoSolucaoId;
      this.payload.nome = this.payload.grupoSolucao.nome;
      this.payload.descricao = this.payload.grupoSolucao.descricao;
      this.solucoes = this.allSolutions
        .filter(
          (item) => item.grupoSolucaoId === this.payload.grupoSolucaoId
        )[0]
        .solucoes.sort((a, b) => compare(a, b, "nome"));
    },
    getGroupSolution() {
      groupSolutionAPI
        .listNotInCity(this.$route.params.id || this.payload.municipioValor)
        .then((resp) => {
          this.allSolutions = resp.data.sort((a, b) => compare(a, b, "nome"));
          this.groupSolutionList = resp.data.sort((a, b) =>
            compare(a, b, "nome")
          );
        })
        .catch();
    },
  },
  mounted() {
    if (!this.possuiMunicipio) this.getGroupSolution();
  },
};
</script>
